import { apiFetch } from "@/lib/jwt-auth-client";

/**
 * Upload a brand logo to storage and return its public URL.
 *
 * Stored as the brand's `assets.logo` so it round-trips cleanly through:
 *   - the brand-config artifact (PUT /brands/:id/)
 *   - `buildBrandContextSnapshot` (`assets.logoUrl`)
 *   - the Banan image-ad dispatch (`reference_image_urls` — Banan's
 *     `generate_image` handler does `fetch(url)` on each entry, so a
 *     data: URL would 404; the CDN URL returned here is reachable).
 */
export async function uploadBrandLogo(file: File): Promise<string> {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("subject", "brand:logo");
  const res = await apiFetch("/api/artifacts/upload-image/", {
    method: "POST",
    body: fd,
  });
  if (!res.ok) {
    throw new Error(`Logo upload failed (${res.status})`);
  }
  const data = (await res.json()) as { url?: string; cdn_url?: string };
  const url = data.cdn_url || data.url;
  if (!url) throw new Error("Upload returned no URL");
  return url;
}
